export default "__VITE_ASSET__Dv3a9LSw__"